import React from 'react';
import Left from './Components/Left/Left.jsx';
import Right from './Components/Right/Right.jsx';

function Body() {
  return (
    <>
    <div className='container'>
    <Left></Left>
    <Right></Right>
    </div>
    </>
  )
}

export default Body;